module.exports = __webpack_public_path__ + "h5/static/img/tiansheng-logo.7f40d4ad.png";